import styled from "styled-components";

import { ReactComponent as ThickSVG } from "../../../../assets/icons/thick.svg";

import { useEffect, useState } from "react";
import { ReactComponent as LineRedSVG } from "../../../../assets/icons/line_red.svg";
import {
  PricelistOffersGetByIdItems,
  PricelistPackageType,
} from "../../../../services/orders/pricelist-offers-get-by-id/types";
import { StorageAreaPackageType } from "../../../../services/storage-area/get/types";
import Icon from "../../../../components/icon";
import { getPackageTypeEnum } from "../../../operator-views/operator-subcontractors-storage-area/helpers";
import { WarningMessage } from "../../../../components/WarningMessage";
import { getWarehouseServicesEnum } from "../../../../helpers/enum-helper";
import { theme } from "../../../../helpers/theme";
import { StyledDialog } from "../../../../components/dialog/dialog";
import { Button } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { offerClientFinalAccept } from "../../../../services/offers/offer-client-final-accept";
import { offerClientFinalRefuse } from "../../../../services/offers/offer-client-final-refuse";
import { toast } from "react-toastify";
import { settings } from "../../../../helpers/toast.settings";
import { offerSubcontractorRefuse } from "../../../../services/offers/offer-subcontractor-refuse";
import { offerSubcontractorAccept } from "../../../../services/offers/offer-subcontractor-accept";
import { useNavigate } from "react-router";
import { urlSubcontractor } from "../../../../utils/url";
import SessionService from "../../../../services/session-service";

const worning_message: string =
  "Do wyceny tej usługi niezbędna jest konsultacja. Na wskazany przez Ciebie numer telefonu wkrótce zadzwoni nasz konsultant.";
export type OfferItemsByObjects = OfferItem[];

export type OfferItem = {
  data: any[];
  requiresAnAppraisal: boolean;
};
interface OfferViewContentProps {
  pozycje_oferty: PricelistOffersGetByIdItems[];
  additional_services_quantity?: number | null;
  id_zamowienia?: string;
  oferta_id: string;
  id_oferta_podwykonawcy: string;
}

const getDimensionOfPackage = (
  type: StorageAreaPackageType | PricelistPackageType
) => {
  switch (type) {
    case 2:
      return "1200 mm x 800 mm x 1600 mm";
    case 3:
      return "800 mm x 600 mm x 1600 mm";
    default:
      return "";
  }
};

export const SubcontractorOfferViewContent = ({
  pozycje_oferty,
  id_oferta_podwykonawcy,
  additional_services_quantity,
  id_zamowienia,
  oferta_id,
}: OfferViewContentProps) => {
  const navigate = useNavigate();
  const [openOfferDialog, setOpenOfferDialog] = useState(false);
  const [dataIsReady, setDataIsReady] = useState(false);
  const [dataDividedIntoObjects, setDataDividedIntoObjects] =
    useState<OfferItemsByObjects>();

  const divisionIntoObjects = (
    pozycje_oferty: PricelistOffersGetByIdItems[]
  ): OfferItemsByObjects => {
    let paleta_eur: PricelistOffersGetByIdItems[] = []; //2
    let paleta_polowa_eur: PricelistOffersGetByIdItems[] = []; //3
    let requiresAnAppraisal_paleta_eur: boolean = false;
    let requiresAnAppraisal_paleta_polowa_eur: boolean = false;

    pozycje_oferty.map((item: PricelistOffersGetByIdItems) => {
      if (item.obiekt === 2) {
        paleta_eur.push(item);
        if (item.wymaga_wyceny) {
          requiresAnAppraisal_paleta_eur = true;
        }
      } else {
        paleta_polowa_eur.push(item);
        if (item.wymaga_wyceny) {
          requiresAnAppraisal_paleta_polowa_eur = true;
        }
      }
    });
    setDataDividedIntoObjects([
      {
        data: paleta_eur,
        requiresAnAppraisal: requiresAnAppraisal_paleta_eur,
      },
      {
        data: paleta_polowa_eur,
        requiresAnAppraisal: requiresAnAppraisal_paleta_polowa_eur,
      },
    ]);

    setDataIsReady(true);
    return [
      {
        data: paleta_eur,
        requiresAnAppraisal: requiresAnAppraisal_paleta_eur,
      },
      {
        data: paleta_polowa_eur,
        requiresAnAppraisal: requiresAnAppraisal_paleta_polowa_eur,
      },
    ];
  };

  useEffect(() => {
    divisionIntoObjects(pozycje_oferty);
  }, [dataIsReady]);

  const acceptOfferMutation = useMutation(offerSubcontractorAccept, {
    onSuccess: () => {
      toast.success("Zaakceptowano pomyślnie!", {
        toastId: "offerSubcontractorAcceptSuccessfully",
        ...settings,
      });

      navigate(urlSubcontractor.subcontractors);
    },
  });
  const refuseOfferMutation = useMutation(offerSubcontractorRefuse, {
    onSuccess: () => {
      toast.success("Odrzucono pomyślnie!", {
        toastId: "offerSubcontractorRefuseSuccessfully",
        ...settings,
      });

      navigate(urlSubcontractor.subcontractors);
    },
  });

  return (
    <Container>
      <>
        {dataDividedIntoObjects
          ? dataDividedIntoObjects.map((object, index) => (
              <div key={index}>
                {object.data.length > 0 ? (
                  <>
                    {/* <Divider sx={{ marginTop: "16px", marginBottom: "16px" }} /> */}
                    <ObjecTypeWraper key={index}>
                      <Icon
                        height="20px"
                        width="20px"
                        noPadding
                        icon={<ThickSVG />}
                      />
                      <Title>{getPackageTypeEnum(index === 0 ? 2 : 3)}</Title>
                    </ObjecTypeWraper>

                    <WarningWrapper
                      requiresAnAppraisal={object.requiresAnAppraisal}
                    >
                      <WarningMessage message={worning_message} />
                    </WarningWrapper>

                    <Wrapper>
                      <ObjectInfo>
                        <Dimensions>
                          {" "}
                          {getDimensionOfPackage(index === 0 ? 2 : 3)}
                        </Dimensions>
                        <Quantity>Ilość: {object.data[0].ilosc} szt.</Quantity>
                        <TotalArea>
                          Łącznie: {object.data[0].rozmiar_m2} m<sup>2</sup>
                        </TotalArea>
                      </ObjectInfo>

                      <OfferServices>
                        {object.data.map((item) => (
                          <SingleServiceWrapper key={item.id_pozycja_oferty}>
                            <ServicesName>
                              {getWarehouseServicesEnum(item.usluga)}
                            </ServicesName>
                            <ServicesPrice>
                              {item.wymaga_wyceny ? (
                                <Icon
                                  width="14px"
                                  height="20px"
                                  noPadding
                                  icon={<LineRedSVG />}
                                />
                              ) : item.cena_docelowa == null ? null : (
                                `${item.cena_docelowa.toFixed(2)} zł`
                              )}
                            </ServicesPrice>
                          </SingleServiceWrapper>
                        ))}
                      </OfferServices>
                    </Wrapper>

                    <ActionsButtonsWrapper>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: theme.colors.blue01_active,
                        }}
                        onClick={() => {
                          acceptOfferMutation.mutate({
                            id_oferty_podwykonawcy: id_oferta_podwykonawcy,
                            token: null,
                          });
                        }}
                      >
                        Potwierdź
                      </Button>
                      <Button
                        variant="contained"
                        style={{
                          backgroundColor: "red",
                        }}
                        onClick={() => {
                          setOpenOfferDialog(true);
                        }}
                      >
                        Odrzuć
                      </Button>
                      <StyledDialog
                        open={openOfferDialog}
                        setOpen={setOpenOfferDialog}
                        confirmFunction={() =>
                          refuseOfferMutation.mutate({
                            id_oferty_podwykonawcy: id_oferta_podwykonawcy,
                            token: null,
                          })
                        }
                        dialogContent="Czy na pewno chcesz odrzucić ofertę?"
                      />
                    </ActionsButtonsWrapper>
                  </>
                ) : null}
              </div>
            ))
          : null}
      </>
    </Container>
  );
};

const Container = styled.div``;
const ObjecTypeWraper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 8px;
  margin-top: 16px;
`;
const Title = styled.div`
  padding-left: 12px;
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.normal};
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.gray01_secondaryText};
`;
const ObjectInfo = styled.div`
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.normal};
  font-size: 12px;
  line-height: 18px;
  color: ${theme.colors.gray01_secondaryText};
  white-space: nowrap;
  min-width: 230px;
  padding-left: 32px;
`;
const Dimensions = styled.div``;
const Quantity = styled.div`
  padding-top: 8px;
`;
const TotalArea = styled.div`
  margin-top: -6px;
`;
const ActionsButtonsWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
  width: 100%;
  justify-content: flex-end;
`;
const TotalWeight = styled.div`
  padding-top: 8px;
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: inherit; //
  justify-content: space-between;
  align-content: stretch;
  flex-wrap: wrap;
  height: max-content;
  @media (max-width: 604px) {
    flex-direction: column;
    row-gap: 18px;
  }
`;
const OfferServices = styled.div`
  align-self: stretch;
  display: grid;
  width: 50%;
  white-space: nowrap;
  @media (max-width: 604px) {
    width: auto;
    padding-left: 32px;
    padding-right: 16px;
  }
`;
const ServicesName = styled.div`
  width: 50%;
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.small};
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.gray01_secondaryText};
  min-width: 150px;
  @media (max-width: 604px) {
    width: auto;
  }
`;
const ServicesPrice = styled.div`
  width: 50%;
  justify-content: flex-end;
  display: grid;
  font-family: ${theme.fonts.interRegular};
  font-style: normal;
  font-weight: ${theme.fontWeight.small};
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.black_primaryText};
  white-space: nowrap;
`;
const SingleServiceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
`;
const WarningWrapper = styled.div<{
  requiresAnAppraisal: boolean;
}>`
  margin-bottom: 16px;
  margin-top: 8px;
  margin-left: -2px;
  width: 80%;
  display: ${(props: any) => (props.requiresAnAppraisal ? "flex" : "none")};
`;
